"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var highlightValue = function highlightValue(value, highlights) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var classNames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!highlights) {
    return /*#__PURE__*/_react["default"].createElement("span", null, value);
  }

  if ((0, _lodash.isArray)(value)) {
    return value.map(function (v, i) {
      return highlightValue(v, highlights[i], i);
    });
  }

  var val = String(value); // deals with arrays/numbers/...

  var children = [];
  var currentPosition = 0;
  var x = 0;

  for (x = 0; x < highlights.length; x += 1) {
    var nonMatchingPrefix = val.slice(currentPosition, highlights[x].startIndex);
    var matchingText = val.slice(highlights[x].startIndex, highlights[x].startIndex + highlights[x].length);
    currentPosition = highlights[x].startIndex + highlights[x].length;

    if (nonMatchingPrefix.length > 0) {
      children.push( /*#__PURE__*/_react["default"].createElement("span", {
        key: "".concat(x, "-nonmatch")
      }, nonMatchingPrefix));
    }

    children.push( /*#__PURE__*/_react["default"].createElement("span", {
      className: classNames.highlight || 'highlight',
      key: "".concat(x, "-match")
    }, matchingText));
  }

  children.push( /*#__PURE__*/_react["default"].createElement("span", {
    key: "".concat(x, "-remainder")
  }, val.slice(currentPosition)));
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classNames.searchResult || 'search-result',
    key: "result-".concat(index)
  }, children);
};

var _default = highlightValue;
exports["default"] = _default;